var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockV2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.99984C18.3334 14.5998 14.6001 18.3332 10.0001 18.3332C5.40008 18.3332 1.66675 14.5998 1.66675 9.99984C1.66675 5.39984 5.40008 1.6665 10.0001 1.6665C14.6001 1.6665 18.3334 5.39984 18.3334 9.99984Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0917 12.6497L10.5083 11.1081C10.0583 10.8414 9.69165 10.1997 9.69165 9.67472V6.25806",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockV2Icon);
export default __webpack_public_path__ + "static/media/clock-v2-icon.beb333947d49cb18e35b813c2cade13f.svg";
export { ForwardRef as ReactComponent };